import { Lightning, VideoPlayer } from "@lightningjs/sdk";
import { Subject, fromEventPattern, merge, } from "rxjs";
import { map } from "rxjs/operators";
export class DashJSVideoPlayer extends Lightning.Component {
    constructor(...args) {
        super(...args);
        this._href = "";
        this._currentTime = 0;
        this._duration = 0;
        this._buffering$ = new Subject();
        this._duration$ = new Subject();
        this._currentTime$ = new Subject();
        this._events$ = new Subject();
        this._playing$ = new Subject();
        this._subscriptions = [];
        this.buffering$ = this._buffering$.asObservable();
        this.currentTime$ = this._currentTime$.asObservable();
        this.duration$ = this._duration$.asObservable();
        this.events$ = this._events$.asObservable();
        this.playing$ = this._playing$.asObservable();
        this._loadPlayback = this._loadPlayback.bind(this);
        this._loadPlaybackDashJs = this._loadPlaybackDashJs.bind(this);
        this._unloadPlayback = this._unloadPlayback.bind(this);
        this._unloadPlaybackDashJs = this._unloadPlaybackDashJs.bind(this);
    }
    get href() {
        return this._href;
    }
    set href(href) {
        this._href = href;
    }
    _addSub(observable, callback) {
        this._subscriptions.push(observable.subscribe(callback));
    }
    async _loadPlayback(url, videoEl) {
        const source = document.createElement("source");
        source.setAttribute("src", url);
        source.setAttribute("type", "application/dash+xml");
        videoEl.appendChild(source);
        videoEl.removeAttribute("src");
        videoEl.load();
    }
    async _loadPlaybackDashJs(url, videoEl) {
        if (!this._dashJs) {
            this._dashJs = window.dashjs.MediaPlayer().create();
            this._dashJs.initialize();
        }
        // Setup buffering
        this._addSub(merge(this._register(window.dashjs.MediaPlayer.events.BUFFER_EMPTY).pipe(map(() => true)), this._register(window.dashjs.MediaPlayer.events.BUFFER_LOADED).pipe(map(() => false)), this._register(window.dashjs.MediaPlayer.events.PLAYBACK_WAITING).pipe(map(() => true))), (buffering) => this._buffering$.next(buffering));
        await this._loadPlayback(url, videoEl);
        // The language buttons are placeholders until subtitle selection is wired up.
        this._dashJs.updateSettings({
            streaming: { text: { defaultEnabled: false } },
        });
        this._dashJs.attachView(videoEl);
        this._dashJs.attachSource(url);
    }
    _register(event) {
        return fromEventPattern((handler) => this._dashJs.on(event, handler), (handler) => this._dashJs.off(event, handler));
    }
    async _unloadPlayback(videoEl) {
        videoEl.removeChild(videoEl.firstChild);
        videoEl.load();
    }
    async _unloadPlaybackDashJs(videoEl) {
        await this._unloadPlayback(videoEl);
        this._dashJs.reset();
        this._dashJs.destroy();
        delete this._dashJs;
    }
    _inactive() {
        this._subscriptions.splice(0).forEach((s) => s.unsubscribe());
        VideoPlayer.close();
    }
    pause() {
        VideoPlayer.pause();
    }
    play() {
        VideoPlayer.play();
    }
    seekTo(time) {
        if (!Number.isFinite(time) ||
            !Number.isFinite(this._duration) ||
            this._duration <= 0)
            return;
        VideoPlayer._videoEl.currentTime = Math.min(Math.max(0, time / 1000), 
        // The video player can break and stutter if we try to seek closer than
        // 2s to the edge.
        Math.max(0, this._duration / 1000 - 2));
    }
    skip(delta) {
        this.seekTo(this._currentTime + delta);
    }
    startPlayback() {
        if (this._href) {
            this._dashJs = window.dashjs.MediaPlayer().create();
            this._dashJs.initialize();
            VideoPlayer.consumer(this);
            VideoPlayer.loader(this._loadPlaybackDashJs);
            VideoPlayer.unloader(this._unloadPlaybackDashJs);
            VideoPlayer.open(this._href);
        }
    }
    stop() {
        VideoPlayer.close();
    }
    $videoPlayerDurationChange({ videoElement }) {
        this._duration = Math.round(videoElement.duration * 1000);
        this._duration$.next(this._duration);
    }
    $videoPlayerEvent(eventName) {
        this._events$.next(eventName);
    }
    $videoPlayerPause() {
        this._playing$.next(false);
    }
    $videoPlayerPlaying() {
        this._playing$.next(true);
    }
    $videoPlayerTimeUpdate(_, currentTime) {
        this._currentTime = currentTime * 1000;
        this._currentTime$.next(this._currentTime);
    }
}
export default DashJSVideoPlayer;
//# sourceMappingURL=DashJSVideoPlayer.js.map